import { dateFormat, parseDate } from '@mirai/locale';

import { formatPrice } from '../helpers/legacy';

const FORMAT_DATE = { delimiter: '-', format: 'YYYY-MM-DD' };

export const bookingResponse = ({
  instances = [],
  response: { tracking = {} } = {},
  store: { hotel: { id } = {}, locale } = {},
} = {}) => {
  // ! -- TODO: use of tracking should be a temporary approach ---------------------------------------------------------
  const {
    bookingValues: { checkin, checkout } = {},
    guestData: { emailSHA256 } = {},
    hotelInfo = {},
    idReservation,
    pendingPayment,
    totalPriceWithoutTaxes,
  } = tracking;

  window.gtag('set', 'user_data', { sha256_email_address: emailSHA256 });

  if (pendingPayment) return;

  const { currency: hotelCurrency = {} } = hotelInfo;
  const item = {
    id,
    start_date: checkin && dateFormat(parseDate(checkin), { ...FORMAT_DATE, locale }),
    end_date: checkout && dateFormat(parseDate(checkout), { ...FORMAT_DATE, locale }),
  };

  const value = {
    currency: hotelCurrency.code,
    items: [item],
    ...item,
    send_to: instances.map(({ conversionLabel, idAdwords } = {}) => `AW-${idAdwords}/${conversionLabel}`),
    transaction_id: idReservation,
    value: formatPrice(totalPriceWithoutTaxes, hotelCurrency),
  };

  window.gtag('event', 'purchase', value);

  return value;
};
